import getOr from 'lodash/fp/getOr';
import { genSelect, genUnit } from './select';

const $ = window.jQuery;

export const additionCodedata = {
  "fields": [
    {
      name: "mf",
      label: "Milk fat",
      unit: "(% by weight)",
      hint: "",
      type: "select",
      value: [
        "=> 0 < 1,5",
        "=> 1,5 < 3",
        "=> 3 < 6",
        "=> 6 < 9",
        "=> 9 < 12",
        "=> 12 < 18",
        "=> 18 < 26",
        "=> 26 < 40",
        "=> 40 < 55",
        "=> 55 < 70",
        "=> 70 < 85",
        "=> 85"
      ]
    },
    {
      name: "mp",
      label: "Milk proteins",
      unit: "(% by weight)",
      hint: "<b>Milk-proteins:</b> Caseins and/or caseinates forming part of goods shall not be regarded as milk proteins if the goods do not have any other constituent of lactic origin. Milkfat contained in the goods at less than 1% ,and lactose at less than 1% by weight, are not considered as other constituents of lactic origin. When customs formalities are completed, the person concerned must include in the appropriate declaration:\"only milk ingredient:casein/caseinate\" if such is the case.",
      type: "select",
      value: [
        "=> 0 < 2,5",
        "=> 0 < 4",
        "=> 0 < 6",
        "=> 2,5 < 6",
        "=> 2,5 < 12",
        "=> 4 < 15",
        "=> 6 < 18",
        "=> 6",
        "=> 12",
        "=> 15",
        "=> 18 < 30",
        "=> 18",
        "=> 30 < 60",
        "=> 60",
        "=> 0 < 100"
      ]
    },
    {
      name: "sg",
      label: "Starch/Glucose",
      unit: "(% by weight)",
      hint: "<b>Starch/Glucose:</b> The content of the goods (as presented) in starch, its degradation products i.e. all the ploymers of glucose, and the glucose, determined as glucose and expressed as starch (on a dry matter basis, 100% punty, factor for conversion of glucose to starch: 0,9). However, where a mixture of glucose and fructose is declared (in whatever form) and/or is found to be present in the goods, the amount of glucose to be included in the above calculation is that which is in excess of the fructose content of the goods.",
      type: "select",
      value: [
        "=> 0 < 5",
        "=> 5 < 25",
        "=> 25 < 50",
        "=> 50 < 75",
        "=> 75"
      ]
    },
    {
      name: "sii",
      label: "Sucrose/invert sugar/isoglucose",
      unit: "(% by weight)",
      hint: "<b>Sucrose/Invert-sugar/Isoglucose:</b> The content of the goods (as presented), in sucrose, together with the sucrose which results from expressing as sucrose any mixture of glucose and fructose (the arithmetical sum of the amounts of these two sugars multiplied by 0,95), which is declared (in whatever form) and/or found to be present in the goods. However, where the fructose content of the goods is less than the glucose content, the amount of glucose to be included in the above calculation shall be an amount equal, by weight, to that of fructose. Note: In all cases, where a hydrolysis product of lactose is declared, and / or galactose is found to be present among the sugars, then the amount of glucose equal to that of galactose is deducted from the total glucose content before any other calculations are carried out.",
      type: "select",
      value: [
        "=> 0 < 5",
        "=> 5",
        "=> 5 < 30",
        "=> 30",
        "=> 30 < 50",
        "=> 50",
        "=> 50 < 70",
        "=> 70"
      ]
    }
  ],
  "matrix": [
    [
      [
        [
          0, null, 1, null, 2, null, 3, 4
        ],
        [
          5, null, 6, null, 7, null, 8, 9
        ],
        [
          10, null, 11, null, 12, 13, null, null
        ],
        [
          15, null, 16, 17, null, null, null, null
        ],
        [
          758, 759, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      [
        [
          20, null, 21, null, 22, null, 23, 24
        ],
        [
          25, null, 26, null, 27, null, 28, 29
        ],
        [
          30, null, 31, null, 32, 33, null, null
        ],
        [
          35, null, 36, 37, null, null, null, null
        ],
        [
          768, 769, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      [
        [
          40, null, 41, null, 42, null, 43, 44
        ],
        [
          45, null, 46, null, 47, null, 48, 49
        ],
        [
          50, null, 51, null, 52, 53, null, null
        ],
        [
          55, null, 56, 57, null, null, null, null
        ],
        [
          778, 779, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      [
        [
          60, null, 61, null, 62, null, 63, 64
        ],
        [
          65, null, 66, null, 67, null, 68, 69
        ],
        [
          70, null, 71, null, 72, 73, null, null
        ],
        [
          75, null, 76, 77, null, null, null, null
        ],
        [
          788, 789, null, null, null, null, null, null
        ]
      ],
      null,
      [
        [
          80, null, 81, null, 82, null, 83, 84
        ],
        [
          85, null, 86, null, 87, null, 88, null
        ],
        [
          90, null, 91, null, 92, null, null, null
        ],
        [
          95, null, 96, null, null, null, null, null
        ],
        null
      ],
      [
        [
          800, null, 801, null, 802, null, null, null
        ],
        [
          805, null, 806, null, 807, null, null, null
        ],
        [
          810, null, 811, null, null, null, null, null
        ],
        null,
        null
      ],
      null
    ],
    [
      [
        [
          100, null, 101, null, 102, null, 103, 104
        ],
        [
          105, null, 106, null, 107, null, 108, 109
        ],
        [
          110, null, 111, null, 112, 113, null, null
        ],
        [
          115, null, 116, 117, null, null, null, null
        ],
        [
          798, 799, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      [
        [
          120, null, 121, null, 122, null, 123, 124
        ],
        [
          125, null, 126, null, 127, null, 128, 129
        ],
        [
          130, null, 131, null, 132, 133, null, null
        ],
        [
          135, null, 136, 137, null, null, null, null
        ],
        [
          808, 809, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      [
        [
          140, null, 141, null, 142, null, 143, 144
        ],
        [
          145, null, 146, null, 147, null, 148, 149
        ],
        [
          150, null, 151, null, 152, 153, null, null
        ],
        [
          155, null, 156, 157, null, null, null, null
        ],
        [
          818, 819, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      [
        [
          160, null, 161, null, 162, null, 163, 164
        ],
        [
          165, null, 166, null, 167, null, 168, 169
        ],
        [
          170, null, 171, null, 172, 173, null, null
        ],
        [
          175, null, 176, 177, null, null, null, null
        ],
        [
          828, 829, null, null, null, null, null, null
        ]
      ],
      null,
      [
        [
          180, null, 181, null, 182, null, 183, 184
        ],
        [
          185, null, 186, null, 187, null, 188, null
        ],
        [
          190, null, 191, null, 192, null, null, null
        ],
        [
          195, null, 196, null, null, null, null, null
        ],
        null
      ],
      [
        [
          820, null, 821, null, 822, null, null, null
        ],
        [
          825, null, 826, null, 827, null, null, null
        ],
        [
          830, null, 831, null, null, null, null, null
        ],
        null,
        null
      ],
      null
    ],
    [
      [
        [
          840, null, 841, null, 842, null, 843, 844
        ],
        [
          845, null, 846, null, 847, null, 848, 849
        ],
        [
          850, null, 851, null, 852, 853, null, null
        ],
        [
          855, null, 856, 857, null, null, null, null
        ],
        [
          858, 859, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      [
        [
          200, null, 201, null, 202, null, 203, 204
        ],
        [
          205, null, 206, null, 207, null, 208, 209
        ],
        [
          210, null, 211, null, 212, 213, null, null
        ],
        [
          215, null, 216, 217, null, null, null, null
        ],
        [
          220, 221, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      [
        [
          260, null, 261, null, 262, null, 263, 264
        ],
        [
          265, null, 266, null, 267, null, 268, 269
        ],
        [
          270, null, 271, null, 272, 273, null, null
        ],
        [
          275, null, 276, null, null, null, null, null
        ],
        [
          838, null, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      null,
      null,
      null
    ],
    [
      null,
      [
        [
          860, null, 861, null, 862, null, 863, 864
        ],
        [
          865, null, 866, null, 867, null, 868, 869
        ],
        [
          870, null, 871, null, 872, 873, null, null
        ],
        [
          875, null, 876, 877, null, null, null, null
        ],
        [
          878, 879, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      [
        [
          300, null, 301, null, 302, null, 303, 304
        ],
        [
          305, null, 306, null, 307, null, 308, 309
        ],
        [
          310, null, 311, null, 312, 313, null, null
        ],
        [
          315, null, 316, 317, null, null, null, null
        ],
        [
          320, 321, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      [
        [
          360, null, 361, null, 362, null, 363, 364
        ],
        [
          365, null, 366, null, 367, null, 368, 369
        ],
        [
          370, null, 371, null, 372, 373, null, null
        ],
        [
          375, null, 376, null, null, null, null, null
        ],
        [
          378, null, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      null,
      null
    ],
    [
      null,
      null,
      [
        [
          900, null, 901, null, 902, null, 903, 904
        ],
        [
          905, null, 906, null, 907, null, 908, 909
        ],
        [
          910, null, 911, null, 912, 913, null, null
        ],
        [
          915, null, 916, 917, null, null, null, null
        ],
        [
          918, 919, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      [
        [
          400, null, 401, null, 402, null, 403, 404
        ],
        [
          405, null, 406, null, 407, null, 408, 409
        ],
        [
          410, null, 411, null, 412, 413, null, null
        ],
        [
          415, null, 416, 417, null, null, null, null
        ],
        [
          420, 421, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      null,
      [
        [
          460, null, 461, null, 462, null, 463, 464
        ],
        [
          465, null, 466, null, 467, null, 468, null
        ],
        [
          470, null, 471, null, 472, null, null, null
        ],
        [
          475, null, 476, null, null, null, null, null
        ],
        null
      ],
      null,
      null,
      null
    ],
    [
      null,
      null,
      [
        [
          940, null, 941, null, 942, null, 943, 944
        ],
        [
          945, null, 946, null, 947, null, 948, 949
        ],
        [
          950, null, 951, null, 952, 953, null, null
        ],
        [
          955, null, 956, 957, null, null, null, null
        ],
        [
          958, 959, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      [
        [
          500, null, 501, null, 502, null, 503, 504
        ],
        [
          505, null, 506, null, 507, null, 508, 509
        ],
        [
          510, null, 511, null, 512, 513, null, null
        ],
        [
          515, null, 516, 517, null, null, null, null
        ],
        [
          520, 521, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      null,
      [
        [
          560, null, 561, null, 562, null, 563, 564
        ],
        [
          565, null, 566, null, 567, null, 568, null
        ],
        [
          570, null, 571, null, 572, null, null, null
        ],
        [
          575, null, 576, null, null, null, null, null
        ],
        null
      ],
      null,
      null,
      null
    ],
    [
      null,
      null,
      [
        [
          960, null, 961, null, 962, null, 963, 964
        ],
        [
          965, null, 966, null, 967, null, 968, 969
        ],
        [
          970, null, 971, null, 972, 973, null, null
        ],
        [
          975, null, 976, 977, null, null, null, null
        ],
        [
          978, 979, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      [
        [
          600, null, 601, null, 602, null, 603, 604
        ],
        [
          605, null, 606, null, 607, null, 608, 609
        ],
        [
          610, null, 611, null, 612, 613, null, null
        ],
        [
          615, null, 616, null, null, null, null, null
        ],
        [
          620, null, null, null, null, null, null, null
        ]
      ],
      null,
      null,
      null,
      null,
      null,
      null,
      null
    ],
    [
      null,
      null,
      [
        [
          980, null, 981, null, 982, null, 983, 984
        ],
        [
          985, null, 986, null, 987, null, 988, null
        ],
        [
          990, null, 991, null, 992, null, null, null
        ],
        [
          995, null, 996, null, null, null, null, null
        ],
        null
      ],
      null,
      null,
      null,
      [
        [
          700, null, 701, null, 702, null, 703, null
        ],
        [
          705, null, 706, null, 707, null, 708, null
        ],
        [
          710, null, 711, null, 712, null, null, null
        ],
        [
          715, null, 716, null, null, null, null, null
        ],
        null
      ],
      null,
      null,
      null,
      null,
      null,
      null,
      null
    ],
    [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [
        [
          720, null, 721, null, 722, null, 723, null
        ],
        [
          725, null, 726, null, 727, null, 728, null
        ],
        [
          730, null, 731, null, 732, null, null, null
        ],
        [
          735, null, 736, null, null, null, null, null
        ],
        null
      ],
    ],
    [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [
        [
          740, null, 741, null, 742, null, null, null
        ],
        [
          745, null, 746, null, 747, null, null, null
        ],
        [
          750, null, 751, null, null, null, null, null
        ],
        null,
        null
      ],
    ],
    [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [
        [
          760, null, 761, null, 762, null, null, null
        ],
        [
          765, null, 766, null, null, null, null, null
        ],
        [
          770, null, 771, null, null, null, null, null
        ],
        null,
        null
      ],
    ],
    [
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      [
        [
          780, null, 781, null, null, null, null, null
        ],
        [
          785, null, 786, null, null, null, null, null
        ],
        null,
        null,
        null
      ],
    ]
  ]
}

export const getAdditionCode = (...params) => {
  let query = 'matrix';
  params.forEach(element => {
    query += `[${element}]`;
  });
  return getOr(null, query)(additionCodedata);
}

export const getFullAdditionCode = () => {
  const param = [];
  for (let i = 0; i < additionCodedata.fields.length; i++) {
    param.push($(`.form-group.${additionCodedata.fields[i].name} .input-box .input [name=${additionCodedata.fields[i].name}]`).val() * 1);
  }
  return getAdditionCode(...param);
}

export const getCodeInfo = (...params) => {
  const result = {};
  params.forEach((element, index) => {
    result[additionCodedata.fields[index].name] = {
      ...additionCodedata.fields[index],
      value: additionCodedata.fields[index].value[element]
    }
  });
  return {
    ...result,
    value: getAdditionCode(...params)
  }
}

export const getSelectOptions = (...param) => {
  let result = [];
  if (param.length >= additionCodedata.fields.length) {
    return result;
  }
  let data = additionCodedata.matrix;
  let i = -1;

  for (let index = 0; index < param.length; index++) {
    const item = param[index];
    if (Array.isArray(data[item])) {
      i = index;
      data = data[item];
    } else {
      data = null;
      break;
    }
  }
  if (data == null) {
    return result;
  }
  data.forEach((item, index) => {
    if (item !== null) {
      result.push({
        label: additionCodedata.fields[i + 1].value[index],
        value: index
      });
    }
  })
  return result;
}

export const genAdditionalInput = (parent, selecter, index = 0) => {
  const data = additionCodedata.fields[index];
  const box = selecter.find('.sub-input-box');
  let hint = '';
  if (data.hint && data.hint !== data.label) {
    hint = `<div class="instruction">
            <div class="dropdown">
              <div class="content">
                ${data.hint}
              </div>
            </div>
          </div>`;
  }
  const oldElement = box.find(`.form-group.${data.name}`);
  if (oldElement.length) {
    oldElement.html(`
    <div class="form-group ${data.name}">
      <label class="label">${data.label}
      ${hint}
      </label>
      <div class='input-box ${data.type}'>
        <div class="input"></div><div class='border'></div><div class="unit ${data.unit}"></div>
      </div>
      <div class="invalid-feedback">
        Please enter a valid ${data.name}.
      </div>
    </div>
  `)
  } else {
    box.append($(`
      <div class="form-group ${data.name}">
        <label class="label">${data.label}
        ${hint}
        </label>
        <div class='input-box ${data.type}'>
          <div class="input"></div><div class='border'></div><div class="unit ${data.unit}"></div>
        </div>
        <div class="invalid-feedback">
          Please enter a valid ${data.name}.
        </div>
      </div>
    `));
  }
  genUnit(box.find(`.form-group.${data.name} .unit`), data.unit);
  const element = additionCodedata.fields[index];
  const param = [];

  for (let i = 0; i < index; i++) {
    param.push(box.find(`.form-group.${additionCodedata.fields[i].name} .input-box .input [name=${additionCodedata.fields[i].name}]`).val() * 1);
  }
  let options = getSelectOptions(...param);
  genSelect(box.find(`.form-group.${data.name} .input-box .input`), options, window.searchData[element.name], element.name, `input-field ${element.name}`, function (value) {
    window.searchData[element.name] = value;
    if (index < additionCodedata.fields.length - 1) {
      genAdditionalInput(parent, selecter, index + 1)
    } else {
      selecter.find(`input[name=${parent.name}]`).val(getFullAdditionCode()).trigger('change');
    }
  }, function (value) {
    window.searchData[element.name] = value;
    if (index < additionCodedata.fields.length - 1) {
      genAdditionalInput(parent, selecter, index + 1)
    } else {
      selecter.find(`input[name=${parent.name}]`).val(getFullAdditionCode()).trigger('change');
    }
  });
}